import { syncFinance } from "./apiClient";

export const FINANCE_SYNCED_EVENT = "finance-synced";
export const FINANCE_STALE_HOURS = 6;

let inFlight = null;
let lastCheckedAt = 0;
const CHECK_COOLDOWN_MS = 5 * 60 * 1000;

function emitIfRan(result) {
  if (result && !result.skipped) {
    window.dispatchEvent(new CustomEvent(FINANCE_SYNCED_EVENT, { detail: result }));
  }
  return result;
}

export function maybeSyncFinanceIfStale() {
  const now = Date.now();
  if (inFlight) return inFlight;
  if (now - lastCheckedAt < CHECK_COOLDOWN_MS) return Promise.resolve(null);

  inFlight = syncFinance({ ifStaleHours: FINANCE_STALE_HOURS })
    .then((result) => {
      lastCheckedAt = Date.now();
      return emitIfRan(result);
    })
    .catch(() => null)
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}

export function forceSyncFinance() {
  return syncFinance({ force: true }).then((result) => {
    lastCheckedAt = Date.now();
    return emitIfRan(result);
  });
}
